/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {FileManagerApi} from '../../api/ms-filemanager/filemanager.api';

@Injectable({
    providedIn: 'root'
})
export class FolderDeleteService {

    constructor(private fileManagerApi: FileManagerApi) {
    }

    /**
     * Delete the S3 storage folder if already exists.
     * @param attachmentDirectory the storage name
     */
    deleteFolder(attachmentDirectory: string): Observable<any> {
        return attachmentDirectory != null ? this.fileManagerApi.deleteDirectory(attachmentDirectory) : of(Promise.resolve());
    }
}
